import http, {download, uploadCfg} from "../../../utils/HttpUtils";


//
class SupplierService {
    //添加供应商
    static async insert(data) {
        const apiUrl = "/base/supplier/insert";
        return await http.post(apiUrl, data);
    }

    //修改供应商
    static async update(data) {
        const apiUrl = "/base/supplier/update";
        return await http.post(apiUrl, data);
    }

    //根据ID查询供应商
    static async findOne(id) {
        const apiUrl = `/base/supplier/findById/${id}`;
        return await http.get(apiUrl);
    }

    //分页查询供应商
    static async findPage(data) {
        const apiUrl = "/base/supplier/listPage";
        return await http.post(apiUrl, data);
    }

    //查询所有供应商列表
    static async findAll() {
        const apiUrl = "/scmSupplier/list";
        return await http.get(apiUrl);
    }

    //启用禁用
    static async enableOrDisable(data) {
        const apiUrl = `/base/supplier/update`;
        return await http.post(apiUrl, data);
    }

    //根据ID删除供应商
    static async deleteOne(id) {
        const apiUrl = `/suppler/delete/${id}`;
        return await http.get(apiUrl);
    }

    //新增供应商账户信息
    static async insertAccount(data) {
        const apiUrl = "/supplerAccount/insert";
        return await http.post(apiUrl, data);
    }
    //更新供应商账户信息
    static async updateAccount(data) {
        const apiUrl = "/supplerAccount/update";
        return await http.post(apiUrl, data);
    }

    //查询供应商账户列表（所有）
    static async findAccountAll(id) {
        const apiUrl = `/base/supplier/account/findAccountPage/${id}`;
        return await http.get(apiUrl);
    }
    //启用禁用
    static async accountEnableOrDisable(data) {
        const apiUrl = `/base/supplier/account/enableOrDisable`;
        return await http.post(apiUrl, data);
    }
    //调整账户授信额度
    static async adjustAccount(data) {
        const apiUrl = `/base/supplier/account/adjust`;
        return await http.post(apiUrl,data);
    }
    //账户充值
    static async fillAccount(data){
        const apiUrl = `/base/supplier/account/recharge`;
        return await http.post(apiUrl,data);
    }
    //账户转账
    static async transferAccount(data){
        const apiUrl = `/base/supplier/account/transfer`;
        return await http.post(apiUrl,data);
    }
    //查询账户调额记录
    static async SupplierResizeLimitList(data){
        const apiUrl = `/base/supplier/account/findAdjustPage`;
        return await http.post(apiUrl,data);
    }
    //查询账户转账记录
    static async SupplierTransferAccountsList(data){
        const apiUrl = `/base/supplier/account/findTransferPage`;
        return await http.post(apiUrl,data);
    }
    //查询账户充值记录
    static async SupplierRechargeList(data){
        const apiUrl = `/base/supplier/account/findRechargePage`;
        return await http.post(apiUrl,data);
    }     
    //导出数据
    static async export(res) {
        const apiUrl = "/base/supplier/export";
        await download(apiUrl,res)
    }
    //下载模板
    static async downloadTpl() {
        const apiUrl = "/base/supplier/downloadTpl";
        await download(apiUrl)
    }

    //获取导入配置
    static getImportCfg(cfg) {
        const apiUrl = "/base/supplier/import";
        return uploadCfg(apiUrl, cfg);
    }
}

export default SupplierService;
